export enum ActivityType {
    TOLL = 'TOLL',
    RUC = 'RUC',   
}
